import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ServiceModule } from '../../services/service.module';
import { ChipFilterComponent } from './chip-selector/chip-filter/chip-filter.component';
import { ChipComponent } from './chip-selector/chip/chip.component';
import { EdlProficiencyPillComponent } from './edl-proficiency-pill/edl-proficiency-pill.component';
import { EdlTooltipComponent } from './edl-tooltip/edl-tooltip.component';
import { UrlParamChipFilterComponent } from './chip-selector/url-param-chip-filter/url-param-chip-filter.component';
import { FormErrorIconComponent } from './form-error-icon/form-error-icon.component';
import { SignaturePadModule } from "angular2-signaturepad";

import { SigPadComponent } from './sig-pad/sig-pad.component';
import { PaetepSignatureComponent } from './paetep-signature/paetep-signature.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PaetepSortByComponent } from './paetep-sort-by/paetep-sort-by.component';
import { PaetepPaginationComponent } from './paetep-pagination/paetep-pagination.component';
import { EdlCommonComponentsModule } from '@edl-development/edl-common';
import { PaetepSearchComponent } from './paetep-search/paetep-search.component';
import { PaetepResetButtonComponent } from './paetep-reset-button/paetep-reset-button.component';
import { LaddaModule } from 'angular2-ladda';
import { PaetepLoadingContainerComponent } from './paetep-loading-container/paetep-loading-container.component';

@NgModule({
  declarations: [
    EdlTooltipComponent,
    EdlProficiencyPillComponent,
    ChipComponent,
    ChipFilterComponent,
    UrlParamChipFilterComponent,
    FormErrorIconComponent,
    SigPadComponent,
    PaetepSignatureComponent,
    PaetepSortByComponent,
    PaetepPaginationComponent,
    PaetepSearchComponent,
    PaetepResetButtonComponent,
    PaetepLoadingContainerComponent
  ],
  exports: [
    EdlTooltipComponent,
    EdlProficiencyPillComponent,
    ChipFilterComponent,
    ChipComponent,
    UrlParamChipFilterComponent,
    FormErrorIconComponent,
    SigPadComponent,
    PaetepSignatureComponent,
    PaetepSortByComponent,
    PaetepPaginationComponent,
    PaetepSearchComponent,
    PaetepResetButtonComponent,
    PaetepLoadingContainerComponent
  ],
  imports: [
    CommonModule,
    EdlCommonComponentsModule,
    NgbModule,
    ServiceModule,
    SignaturePadModule,
    FormsModule,
    ReactiveFormsModule,
    LaddaModule
  ]
})
export class ComponentsModule { }
